import base from '@primeuix/themes/lara/base';

import autocomplete from '@primeuix/themes/lara/autocomplete';
import button from '@primeuix/themes/lara/button';
import checkbox from '@primeuix/themes/lara/checkbox';
import confirmpopup from '@primeuix/themes/lara/confirmpopup';
import iconfield from '@primeuix/themes/lara/iconfield';
import inputtext from '@primeuix/themes/lara/inputtext';
import listbox from '@primeuix/themes/lara/listbox';
import message from '@primeuix/themes/lara/message';
import paginator from '@primeuix/themes/lara/paginator';
import popover from '@primeuix/themes/lara/popover';
import progressspinner from '@primeuix/themes/lara/progressspinner';
import ripple from '@primeuix/themes/lara/ripple';
import select from '@primeuix/themes/lara/select';
import tooltip from '@primeuix/themes/lara/tooltip';
import tree from '@primeuix/themes/lara/tree';
import virtualscroller from '@primeuix/themes/lara/virtualscroller';

/**
 * The Lara preset, reduced to the components this app renders.
 *
 * `@primeuix/themes/lara` bundles design tokens for 100 components (~187 kB of source)
 * and is imported eagerly by AppModule, so every visitor downloaded all of it. This app
 * renders five PrimeNG components: autocomplete and tree on the help pages, paginator on
 * the FAQ, select and confirmpopup in registration, profile and support.
 *
 * IMPORTANT — adding a PrimeNG component elsewhere means adding its tokens here, or it
 * renders unstyled. The token names match the module names: `<p-datepicker>` needs
 * `@primeuix/themes/lara/datepicker`.
 *
 * The list is wider than those five on purpose, because PrimeNG components render other
 * PrimeNG components internally — paginator contains a select, confirmpopup a button,
 * autocomplete an inputtext and an iconfield. Those entries cost little and removing
 * them on a hunch is how this breaks quietly.
 *
 * `base` is not optional: it carries the color palettes and the semantic tokens
 * (surface, form, focus, overlay, typography) that every component token refers to.
 */
export const LaraSubset = {
  ...base,
  components: {
    autocomplete,
    button,
    checkbox,
    confirmpopup,
    iconfield,
    inputtext,
    listbox,
    message,
    paginator,
    popover,
    progressspinner,
    ripple,
    select,
    tooltip,
    tree,
    virtualscroller,
  },
};
